import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Grid,
  Paper,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Avatar,
  withStyles,
  TableCell,
} from "@material-ui/core";
import BodyText from "./BodyText";
import DashboardTable from "./DashboardTable";
import DashboardTable2 from "./DashboardTable2";
import { useDispatch, useSelector } from "react-redux";
import TitleText from "./TitleText";
import { agenttransactionhistoryDispatch } from "../../reducers/UserReducer";
const tableHeaders = [
  "ID",
  "TYPE",
  "CART_ID",
  "DOJ",
  "COMMISSION",
  "MARKUP",
  "AMOUNT",
  "AVAL_BAL",
  "PAY_TYPE",
  "DATE",
  "HOLD_S",
  "TRANS_S",
  "DESC",
];

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontWeight: 600,

    // padding: 3,
    fontSize: 12,
    textTransform: "uppercase",
    background: "aliceblue",
  },
  root: {
    borderBottom: "none",
    paddingBottom: 0,
  },
}))(TableCell);
const TransactionHistory = () => {
  const { transagent, agentlogin } = useSelector((state) => state.user);
  const [val, setVal] = useState("");
  const [data, setData] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      agenttransactionhistoryDispatch(agentlogin && agentlogin.result.result.id)
    );
  }, []);
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let results = [];
    console.log(value);
    setVal(value);

    results =
      transagent &&
      transagent.result &&
      transagent.result.result.filter((item) => {
        return (
          item.payment_type.toLowerCase().includes(value.toLowerCase()) ||
          item.doj.toLowerCase().includes(value.toLowerCase()) ||
          item.amount.toLowerCase().includes(value.toLowerCase()) ||
          item.type.toLowerCase().includes(value.toLowerCase())||
          item.cart_id.toLowerCase().includes(value.toLowerCase())||
          item.markup.toLowerCase().includes(value.toLowerCase())
        );
      });
    setData(results);
    // console.log(results);
  };
  console.log("Result", data);
  return (
    <>
      <Box
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          display: "flex",
        }}
      >
        <h2 style={{ fontFamily: "Josefin Sans, sans-serif" }}>
          Transaction History
        </h2>
        <Box>
          <i
            class="fa fa-search icon"
            style={{ background: "white", padding: "14px" }}
          >
            {" "}
          </i>
          <input
            type="search"
            style={{ padding: "13px" }}
            placeholder="Search"
            value={val}
            onChange={handleSearch}
            //   className="form-control form-control-sm"
          />
        </Box>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TableContainer style={{ marginTop: 15 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {tableHeaders.map((title, index) => (
                    <StyledTableCell key={title}>{title}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  ? data.length > 0 &&
                    data?.map((item, index) => {
                      return <DashboardTable2 rowIndex={index} item={item} />;
                    })
                  : transagent &&
                    transagent.result &&
                    transagent.result.result?.length > 0 &&
                    transagent.result.result?.map((item, index) => {
                      return <DashboardTable2 rowIndex={index} item={item} />;
                    })}
                {/* {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i, index) => {
									return
								})} */}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Box style={{ marginTop: 20, marginBottom: 50,display:'flex',alignItems:'center' }}>
        <h4>Total Amount</h4>
        <h4 style={{marginLeft:10}}>
          {" "}
          ₹
          {data
            ? data?.length>0&&data?.map((item) => parseInt(item.amount))
                .reduce((prev, next) => prev + next)
            : transagent &&
              transagent?.result &&
              transagent?.result?.result?.map((item) => parseInt(item.amount))
                .reduce((prev, next) => prev + next)}
        </h4>
      </Box>
    </>
  );
};

export default TransactionHistory;
